import React, { useEffect, useState } from "react";
import {
	Button,
	Container,
	Grid,
	Tooltip,
	Toolbar,
	CircularProgress,
} from "@mui/material";
import WorkIcon from "@mui/icons-material/Work";

import AddIcon from "@mui/icons-material/Add";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Table from "../../components/table/Table";
import { Widget } from "../../components/widget/Widget";
import {
	Delete,
	ConfirmationNumber,
} from "@mui/icons-material";
import AddModal from "./AddModal";
import {
	deletePromoBatch,
	getAllCampaignPromo,
	getAllPromoBatch,
	getAllPromos,
} from "../../redux/actions/promocode.actions";
import { useDispatch, useSelector } from "react-redux";
import Promos from "./Promos";
import { getAllClients } from "../../redux/actions/client.actions";
import StatsCard from "../../components/Comman/cards";
import CardWithButton from "../../components/Comman/button-new";


const Promocode = () => {
	const { campaigns, promoBatches, promos, loading } = useSelector(
		(state) => state.promoReducer
	);

	const { clients } = useSelector((state) => state.clientReducer);
	const dispatch = useDispatch();

	const changedate = (isoString) => {
		const date = new Date(isoString);
		const year = date.getFullYear();
		const month = (date.getMonth() + 1).toString().padStart(2, "0");
		const day = date.getDate().toString().padStart(2, "0");
		return `${day}-${month}-${year}`;
	}

	const rows = Array.isArray(promoBatches) ? promoBatches?.map((item) => ({
		...item,
		id: item.campaign_batch_id,
		created_at: changedate(item.createdAt)
	})) : "";



	const columns = [
		{ field: "id", headerName: "Batch ID", flex: 0.5 },
		{ field: "campaign_id", headerName: "Campaign ID", flex: 0.5 },

		{
			field: "client_name",
			headerName: "Client",
			flex: 1,
			editable: true,
		},
		{
			field: "campaign_name",
			headerName: "Campaign",
			flex: 1,
			editable: true,
		},
		{
			field: "created_at",
			headerName: "Created At",
			flex: 1,
			editable: true,
		},
		{
			field: "actions",
			headerName: "Actions",
			flex: 0.5,
			sortable: false,
			renderCell: (params) => (
				<Box>
					<Tooltip title='View voucher codes'>
						<IconButton
							onClick={() => {
								handlePromos(params.row.campaign_batch_id);
							}}>
							<ConfirmationNumber sx={{ color: "rgba(0, 165, 162, 0.7)" }} />
						</IconButton>
					</Tooltip>
					<Tooltip title='Delete brand'>
						<IconButton
							onClick={() => {
								handleDelete(params.row.campaign_batch_id);
							}}>
							<Delete color="error" />
						</IconButton>
					</Tooltip>
				</Box>
			),
		},
	];

	const [openModal, setOpenModal] = useState(false);
	const [openDialog, setOpenDialog] = useState(false);

	const handleDialog = (value) => {
		value ? setOpenDialog(value) : setOpenDialog(!openDialog);
	};

	const handleModal = (value) => {
		value ? setOpenModal(value) : setOpenModal(!openModal);
	};
	const handleAlert = (value) => { };

	const handleDelete = (id) => {
		dispatch(deletePromoBatch(id));
	};

	const handlePromos = (id) => {
		sessionStorage.setItem("promoId", id);
		dispatch(getAllPromos(id, 1));
		setOpenDialog(true);
	};

	const active = Array.isArray(promoBatches) ? promoBatches
		.map((item) => item.status)
		.filter((item) => item === 1) : "";

	useEffect(() => {
		dispatch(getAllPromoBatch());
		dispatch(getAllCampaignPromo());
		dispatch(getAllClients());
	}, [dispatch]);


	useEffect(() => {
		if (openDialog === false) {
			sessionStorage.removeItem("promoId")
		}
	}, [openDialog])






	return (
		<Container style={{
			border: "1px solid rgba(0, 0, 0, 0.1)",
			padding: "20px 0px 20px 20px",
			width: "98%",
			marginBottom: "5%"
		}}
			className="shadow-md bg-white rounded ">
			<Grid container direction='column' spacing={5}>
				<Grid
					container
					Item
					direction="row"
					justifyContent="space-evenly"
					alignItems="center"
				>
					<StatsCard heading="TOTAL CLIENT" icon={<WorkIcon />} content={promoBatches?.length ?? 0} />
					<StatsCard heading="ACTIVE CLIENT" icon={<WorkIcon />} content={active?.length ?? 0} />
				</Grid>
				<Grid item className="pt-4">
					<CardWithButton
						title="Add Promo Codes"
						className=""
						buttonLabel="Add Promocode"
						buttonIcon={<AddIcon />}
						buttonClick={() => handleModal(true)}
					/>
				</Grid>
				<Grid item className="pt-4">
					<Table rows={rows} columns={columns} />
				</Grid>
			</Grid>
			{openModal && (
				<AddModal
					clients={clients}
					campaigns={campaigns}
					handleModal={handleModal}
					openModal={openModal}
					handleAlert={handleAlert}
				/>
			)}
			<Promos
				promocodes={promos}
				handleDialog={handleDialog}
				openDialog={openDialog}
				loading={loading}
			/>
		</Container>
	);
};

export default Promocode;
